import Axios from 'axios';
import { Field, Form, Formik } from 'formik';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import React, { useState } from 'react';
import * as Yup from "yup";

const schema = Yup.object().shape({
    name: Yup
        .string()
        .required("Este campo es requerido."),
    email: Yup
        .string()
        .email("Este campo debe ser un email.")
        .required("Este campo es requerido."),
    phone: Yup
        .string()
        .min(6, "Este campo es inválido")
        .required("Este campo es requerido."),
    subject: Yup
        .string()
        .required("Este campo es requerido."),
});

const INITIAL_VALUES = {
    name: "",
    email: "",
    phone: "",
    subject: ""
};

const HubspotForm = () => {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (data, resetForm) => {
        setIsLoading(true);

        var datas = {
            fields: [
                {
                    name: "email",
                    value: data.email
                },
                {
                    name: "firstname",
                    value: data.name
                },
                {
                    name: "phone",
                    value: data.phone
                }
            ],
            context: {
                pageUri: "https://joseeustasiorivera.com/",
                pageName: "Landing",
            },
            skipValidation: false
        };

        Axios.post('https://api.hsforms.com/submissions/v3/integration/submit/8074986/c44b0fbc-7022-4421-bed5-3974e859d813', datas)
            .then(function (response) {
                resetForm(INITIAL_VALUES);
                trackCustomEvent({
                    // string - required - The object that was interacted with (e.g.video)
                    category: "PaginaWeb",
                    // string - required - Type of interaction (e.g. 'play')
                    action: "Click",
                    // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
                    label: "ConstructoraBerdez"
                });
                alert("Gracias por enviar el formulario")
            })
            .finally(() => setIsLoading(false));
    }

    return (
        <section
            // id="form"
            className="position-relative">
            <Formik
                initialValues={INITIAL_VALUES}
                validationSchema={schema}
                onSubmit={() => null}>
                {({
                    values,
                    errors,
                    touched,
                    resetForm,
                    isValid
                }) => (
                        <div
                            style={{borderRadius: "1rem"}} 
                            className="px-3 py-5 px-lg-5 bg-white shadow-sm">
                            <Form className="form-hubspot">
                                {/* NAME FIELD */}
                                <div className="form-group">
                                    {/* <label>
                                    Nombres y apellido.
                                                </label> */}
                                    <Field
                                        className="form-control"
                                        name="name"
                                        placeholder="Ingrese su nombre"
                                    />
                                    {errors.name && touched.name && (
                                        <div className="invalid-feedback d-block">
                                            {errors.name}
                                        </div>
                                    )}
                                </div>
                                {/* EMAIL FIELD */}
                                <div className="form-group mt-3">
                                    {/* <label>
                                    Correo electrónico.
                                                </label> */}
                                    <Field
                                        className="form-control"
                                        name="email"
                                        placeholder="Ingrese su correo electrónico."
                                    />
                                    {errors.email && touched.email && (
                                        <div className="invalid-feedback d-block">
                                            {errors.email}
                                        </div>
                                    )}
                                </div>
                                {/* PHONE FIELD */}
                                <div className="form-group mt-3">
                                    {/* <label>
                                    Teléfono.
                                                </label> */}
                                    <Field
                                        className="form-control"
                                        name="phone"
                                        placeholder="Ingrese su número de contacto."
                                    />
                                    {errors.phone && touched.phone && (
                                        <div className="invalid-feedback d-block">
                                            {errors.phone}
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mt-3">
                                    {/* <label>
                                    Teléfono.
                                                </label> */}
                                    <Field
                                        className="form-control"
                                        name="subject"
                                        placeholder="Asunto"
                                        component="textarea"
                                        rows="5"
                                    />
                                    {errors.subject && touched.subject && (
                                        <div className="invalid-feedback d-block">
                                            {errors.subject}
                                        </div>
                                    )}
                                </div>
                                <button
                                    onClick={() => handleSubmit(values, resetForm)}
                                    disabled={!isValid || isLoading}
                                    style={{ top: "5px" }}
                                    type="button"
                                    className="btn btn-sm btn__custom position-relative text-capitalize px-4 py-3">
                                    {isLoading ? "Enviando" : "Solcitar presupuesto"}
                                </button>
                            </Form>
                        </div>
                    )}
            </Formik>
        </section>
    )
}

export default HubspotForm;